const TWO_DECIMALS = /^(\d+)\.(\d{2})$/;

/**
 * The sum of the menu's prices, for display on the review step only.
 *
 * Added in whole paise from the strings, never as floating-point rupees, so "0.10" and "0.20" make
 * "0.30" and not "0.30000000000000004". It is not what the salon charges: the salon prices the visit
 * when it is booked. Returns null when any price is not a plain two-decimal amount, so the screen
 * shows the lines and no total rather than a wrong one.
 */
export function menuTotal(prices: readonly string[]): string | null {
  let paise = 0;
  for (const price of prices) {
    const match = TWO_DECIMALS.exec(price);
    if (!match) return null;
    paise += Number(match[1]) * 100 + Number(match[2]);
    if (!Number.isSafeInteger(paise)) return null;
  }
  return `${Math.floor(paise / 100)}.${String(paise % 100).padStart(2, "0")}`;
}
